import angular from 'angular';

export default angular.module('licenseModule', [
    'core.ui',
    'ui.router',
    'asDoughnutChart',
    'asProgressSteps',
    'asEula',
    'asWorkflow',
    'asCopy',
    'shared'
]);



// WEBPACK FOOTER //
// ./modules/license/license.module.js